exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome[data-v-99a05ed2] {\n  font-size: 30px;\n  font-family: Source Han Sans CN;\n  font-weight: bold;\n  color: #1f8df2;\n  text-align: center;\n  margin: 40px 0;\n}\n.login-btn[data-v-99a05ed2] {\n  height: 40px;\n  background: #1F8DF2;\n  border-radius: 20px;\n  border: none;\n}\n", ""]);

// exports
